/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const postApiEmployeesIdCvRequestUpdatePathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const postApiEmployeesIdCvRequestUpdate200Schema = z.object({
  emailSent: z.boolean(),
  requestedAt: z.string().datetime({ local: true }),
});

export const postApiEmployeesIdCvRequestUpdateMutationRequestSchema = z
  .object({
    sendEmail: z.boolean().optional(),
  })
  .nullable();

export const postApiEmployeesIdCvRequestUpdateMutationResponseSchema = z.lazy(
  () => postApiEmployeesIdCvRequestUpdate200Schema,
);
